const actionTypes = {
    CHANGE_UPLOAD_TYPE: "CHANGE_UPLOAD_TYPE",
    EDIT_LIMITED_TO_TEAMS: "EDIT_LIMITED_TO_TEAMS_FOR_BULK_UPLOADS",
    EDIT_IS_VISIBLE_TO_PARTNERS: "EDIT_IS_VISIBLE_TO_PARTNERS_FOR_BULK_UPLOADS",

    // upload file
    UPLOAD_FILE_START: "UPLOAD_FILE_START",
    UPLOAD_FILE_SUCCESS: "UPLOAD_FILE_SUCCESS",
    UPLOAD_FILE_FAIL: "UPLOAD_FILE_FAIL",

    // upload headers
    UPLOAD_HEADERS_START: "UPLOAD_HEADERS_START",
    UPLOAD_HEADERS_SUCCESS: "UPLOAD_HEADERS_SUCCESS",
    UPLOAD_HEADERS_FAIL: "UPLOAD_HEADERS_FAIL",

    // get user's custom fields
    GET_CUSTOM_FIELDS_START: "GET_CUSTOM_FIELDS_START",
    GET_CUSTOM_FIELDS_SUCCESS: "GET_CUSTOM_FIELDS_SUCCESS",
    GET_CUSTOM_FIELDS_FAIL: "GET_CUSTOM_FIELDS_FAIL",

    // matching fields
    FIELDS_MAKE_MATCH_ON_SELECTED: "DND_MAKE_MATCH_ON_SELECTED",
    FIELDS_MAKE_MATCH: "DND_MAKE_MATCH",
    FIELDS_REMOVE_MATCH: "DND_REMOVE_MATCH",
    FIELDS_SELECT_NEXT: "FIELDS_SELECT_NEXT",

    // getting the link for a Bulk Upload in the Resource Table
    GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_START: "GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_START",
    GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_SUCCESS: "GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_SUCCESS",
    GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_FAIL: "GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_FAIL",

    // progress
    RESET_STATE: "RESET_STATE",
}
export default actionTypes

export const uploadFile = {
    start: actionTypes.UPLOAD_FILE_START,
    success: actionTypes.UPLOAD_FILE_SUCCESS,
    fail: actionTypes.UPLOAD_FILE_FAIL,
}

export const uploadHeaders = {
    start: actionTypes.UPLOAD_HEADERS_START,
    success: actionTypes.UPLOAD_HEADERS_SUCCESS,
    fail: actionTypes.UPLOAD_HEADERS_FAIL,
}

export const getCustomFields = {
    start: actionTypes.GET_CUSTOM_FIELDS_START,
    success: actionTypes.GET_CUSTOM_FIELDS_SUCCESS,
    fail: actionTypes.GET_CUSTOM_FIELDS_FAIL,
}

export const matchFields = {
    makeMatchOnSelected: actionTypes.FIELDS_MAKE_MATCH_ON_SELECTED,
    makeMatch: actionTypes.FIELDS_MAKE_MATCH,
    removeMatch: actionTypes.FIELDS_REMOVE_MATCH,
    selectNextUserField: actionTypes.FIELDS_SELECT_NEXT,
}

export const progress = {
    resetState: actionTypes.RESET_STATE,
}

export const getBulkUploadLinkForResourceTableRow = {
    start: actionTypes.GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_START,
    success: actionTypes.GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_SUCCESS,
    fail: actionTypes.GET_BULK_UPLOAD_LINK_FOR_RESOURCE_TABLE_ROW_FAIL,
}
